import { Switch } from "@mui/material";
import * as React from "react";
import CustomizeItem from "./CustomizeItem";

interface Props {
    enabled: boolean;
    onChange: () => void;
}

export default function ChannelHlsSettings({ enabled, onChange }: Props) {
    return (
        <CustomizeItem
            title={"Enable HLS"}
            description={
                "Enables the output of HLS on top of the default HESP output. HLS will be streamed at a higher latency but will be used for fallback on legacy devices and casting."
            }
            customizationActions={<Switch checked={enabled} color={"secondary"} onChange={onChange} />}
        />
    );
}
